import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Form, Button, Row, Col } from 'react-bootstrap';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import FormContainer from '../../components/FormContainer';
import { toast } from 'react-toastify';
import { useLayout } from '../../context/LayoutContext';

import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import {
  CATEGORY_OF_STAFF,
  REASON_FOR_REQUEST,
} from '../../utils/enums';

import {
  useGetShiftByIdQuery,
  useUpdateShiftMutation,
} from '../../slices/shiftApiSlice';
import { useGetHospitalLocationsQuery } from '../../slices/hospitalLocationApiSlice';

const ShiftWardEditScreen = () => {
  const { id: shiftId } = useParams();
  const navigate = useNavigate();
const { setFluid } = useLayout();
const { userInfo } = useSelector((state) => state.auth);

  const [startDateTime, setStartDateTime] = useState('');
  const [endDateTime, setEndDateTime] = useState('');


const [actualStart, setActualStart] = useState('');
  const [actualFinish, setActualFinish] = useState('');
  const [actualPersonWorked, setActualPersonWorked] = useState('');
 
 const [actualStatus, setActualStatus] = useState('');

  const [hospitalLocationId, setHospitalLocationId] = useState('');
  const [wardDepartmentArea, setWardDepartmentArea] = useState('');
  const [reasonForRequest, setReasonForRequest] = useState('');
  const [reasonForRequestDetails, setReasonForRequestDetails] = useState('');
  const [categoryOfStaff, setCategoryOfStaff] = useState('');
  const [escort, setEscort] = useState(false);
  const [special, setSpecial] = useState(false);
  //const [typeOfShift, setTypeOfShift] = useState('');
  const [eccNumber, setEccNumber] = useState('');
  const [specialRequirements, setSpecialRequirements] = useState('');
  const [comments, setComments] = useState('');
const [stage2WardApprovalManager,setStage2WardApprovalManager]=useState('');
const [copyActualsChecked, setCopyActualsChecked] = useState(false);
  


  const {
    data: shift,
    isLoading: loadingShift,
    error: errorShift,
  } = useGetShiftByIdQuery(shiftId);

  const {
    data: hospitalLocations,
    isLoading: loadingLocations,
    error: errorLocations,
  } = useGetHospitalLocationsQuery();

  const [updateShift, { isLoading: loadingUpdate }] = useUpdateShiftMutation();

  useEffect(() => {
    if (shift && hospitalLocations?.length > 0) {
      setStartDateTime(shift.startDateTime?.slice(0, 16));
      setEndDateTime(shift.endDateTime?.slice(0, 16));

      const selectedHospitalId =
        typeof shift.hospitalLocationId === 'string'
          ? shift.hospitalLocationId
          : shift.hospitalLocationId?._id;

      setHospitalLocationId(selectedHospitalId);

      const selectedLocation = hospitalLocations.find(
        (loc) => loc._id === selectedHospitalId
      );
      setWardDepartmentArea(selectedLocation?.wardDepartmentArea || '');

      setReasonForRequest(shift.reasonForRequest);
       setReasonForRequestDetails(shift.reasonForRequestDetails);
      setCategoryOfStaff(shift.categoryOfStaff);
      setEscort(shift.escort);
      setSpecial(shift.special);
      //setTypeOfShift(shift.typeOfShift);
      setEccNumber(shift.eccNumber);
      setSpecialRequirements(shift.specialRequirements);
      setComments(shift.comments);
      setActualStart(shift.actualStart);
      setActualFinish(shift.actualFinish);
      setActualPersonWorked(shift.actualPersonWorked);
      setActualStatus(shift.actualStatus);
      setStage2WardApprovalManager(userInfo._id);
    }
  }, [shift, hospitalLocations, userInfo]);

  const submitHandler = async (e) => {
    e.preventDefault();

 {/*
 if (!actualStart.trim() || !actualFinish.trim() || !actualPersonWorked.trim() || !actualStatus.trim()) {
    alert('Please fill in all details before proceeding.');
    return;
  }
*/}

  // Validate that all actuals fields are filled
  if (!actualStart.trim() || !actualFinish.trim() || !actualPersonWorked.trim()) {
    alert('Please fill in all actuals details before proceeding.');
    return;
  }

 // Enhanced validation for actualStatus - must be either "Complete" or "Not-Worked"
  const validStatuses = ['Complete', 'Not-Worked'];
  if (!actualStatus || !validStatuses.includes(actualStatus)) {
    alert('Please select a valid Actual Status: either "Complete" or "Not-Worked".');
    return;
  }
  

   //console.log("hospitalLocationId",hospitalLocationId)
   //console.log("shiftId",shiftId)
    try {
      await updateShift({
        shiftId,
        startDateTime,
        endDateTime,
        hospitalLocationId,
        wardDepartmentArea,
        reasonForRequest,
        reasonForRequestDetails,
        categoryOfStaff,
        escort,
        special,
        
        eccNumber,
        specialRequirements,
        comments,
        actualStart,
  actualFinish,
  actualPersonWorked,
  actualStatus,
  stage2WardApprovalManager,

      }).unwrap();
      toast.success('Shift updated successfully');
      navigate('/admin/approved-filled');
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };


  useEffect(() => {
          // Enable full-width container
          setFluid(true);
      
          return () => {
            // Reset back to normal when screen unmounts
            setFluid(false);
          };
        }, [setFluid]);

  //typeOfShift,
// <h1>Open Ward Shifts for Approval</h1>
  return (
    <FormContainer>
      

      {loadingUpdate && <Loader />}
      {loadingShift || loadingLocations ? (
        <Loader />
      ) : errorShift ? (
        <Message variant="danger">
          {errorShift?.data?.message || errorShift.error}
        </Message>
      ) : errorLocations ? (
        <Message variant="danger">
          {errorLocations?.data?.message || errorLocations.error}
        </Message>
      ) : (
        <Form onSubmit={submitHandler}>

          <Card className="mb-4 custom-card-bg">
  <Card.Header className="fw-bold">Ward Approvals: Actuals</Card.Header>
  <Card.Body>
    <Form.Group controlId="copyActualsCheckbox" className="mb-3">
      <Form.Check
        type="checkbox"
        label="Copy planned Start/End and Staff into Actuals"
        checked={copyActualsChecked}
        onChange={(e) => {
          const checked = e.target.checked;
          setCopyActualsChecked(checked);

          if (checked) {
            setActualStart(startDateTime);
            setActualFinish(endDateTime);
            setActualPersonWorked(shift.filledByName || '');
          }
        }}
      />
    </Form.Group>

    <Row className="mb-3">
      <Col md={3}>
        <Form.Group controlId="actualStart">
          <Form.Label>Actual Start</Form.Label>
          <Form.Control
            type="datetime-local"
            value={actualStart}
            onChange={(e) => setActualStart(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group controlId="actualFinish">
          <Form.Label>Actual Finish</Form.Label>
          <Form.Control
            type="datetime-local"
            value={actualFinish}
            onChange={(e) => setActualFinish(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group controlId="actualPersonWorked">
          <Form.Label>Actual Person Worked</Form.Label>
          <Form.Control
            type="text"
            value={actualPersonWorked}
            onChange={(e) => setActualPersonWorked(e.target.value)}
          />
        </Form.Group>
      </Col>
      <Col md={3}>
        <Form.Group controlId="actualStatus">
          <Form.Label>Actual Status</Form.Label>
          <Form.Select
            value={actualStatus}
            onChange={(e) => setActualStatus(e.target.value)}
          >
            <option value="">Select...</option>
            <option value="Complete">Complete</option>
            <option value="Not-Worked">Not-Worked</option>
          </Form.Select>
        </Form.Group>
      </Col>
    </Row>

    <Form.Group controlId="comments">
      <Form.Label>Comments</Form.Label>
      <Form.Control
        as="textarea"
        rows={3}
        value={comments}
        onChange={(e) => setComments(e.target.value)}
      />
    </Form.Group>

    <Button type="submit" variant="primary" className="mt-2">
      Update Shift
    </Button>
  </Card.Body>
</Card>


  <Card className="mb-4 custom-card-bg">
    <Card.Header className="fw-bold">Planned Shift Details</Card.Header>
    <Card.Body>
      <Row className="mb-3">
        <Col md={2}>
          <Form.Group controlId="hospitalLocationId">
            <Form.Label>Hospital Location</Form.Label>
            <Form.Select value={hospitalLocationId} disabled>
              <option value="">Select...</option>
              {hospitalLocations.map((location) => (
                <option key={location._id} value={location._id}>
                  {location.wardDepartmentArea} ({location.department})
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={2}>
          <Form.Group controlId="categoryOfStaff">
            <Form.Label>Category of Staff</Form.Label>
            <Form.Select value={categoryOfStaff} disabled>
              <option value="">Select...</option>
              {CATEGORY_OF_STAFF.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group controlId="reasonForRequest">
            <Form.Label>Reason for Request</Form.Label>
            <Form.Select value={reasonForRequest} disabled>
              <option value="">Select...</option>
              {REASON_FOR_REQUEST.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        <Col md={4}>
          <Form.Group controlId="reasonForRequestDetails">
            <Form.Label>Reason for Request Details</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reasonForRequestDetails}
              readOnly
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Group controlId="startDateTime">
            <Form.Label>Start Date & Time</Form.Label>
            <Form.Control type="datetime-local" value={startDateTime} readOnly />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="endDateTime">
            <Form.Label>End Date & Time</Form.Label>
            <Form.Control type="datetime-local" value={endDateTime} readOnly />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="eccNumber">
            <Form.Label>ECC Number</Form.Label>
            <Form.Control type="text" value={eccNumber} readOnly />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={4}>
          <Form.Label className="fw-bold">Selections</Form.Label>
          <Form.Group controlId="escort" className="mb-2">
            <Form.Check
              type="checkbox"
              label="Escort Required"
              checked={escort}
              disabled
            />
          </Form.Group>
          <Form.Group controlId="special">
            <Form.Check
              type="checkbox"
              label="Is this a Special"
              checked={special}
              disabled
            />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group controlId="specialRequirements" className="mb-2">
        <Form.Label>Any Special Requirements</Form.Label>
        <Form.Control as="textarea" rows={3} value={specialRequirements} readOnly />
      </Form.Group>
    </Card.Body>
  </Card>


  





 




</Form>
      )}
    </FormContainer>
  );
};

export default ShiftWardEditScreen;


